'use client';

import { c as _c } from "react/compiler-runtime";
import { type CSSProperties, useEffect, useState } from 'react';
import { LogoIsuzu } from '@/app/lcv/components/logo/isuzu';
import { BlackLayer } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/black-layer';
import { LOADING_VEIL_FADE_OUT_SECONDS, LOADING_VEIL_VARIANTS } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/loading-veil/config';
import type { LoadingVeilProps } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/loading-veil/types';
import styles from '@/app/lcv/components/sections/spartan/engine/styles.module.css';
import { cn } from '@/app/utils/cn';
export const LoadingVeil = t0 => {
  const $ = _c(17);
  const {
    isVisible,
    variant: t1,
    className: extraClassName
  } = t0;
  const variant = t1 === undefined ? "firstLoad" : t1;
  const {
    className,
    isRemovedOnceHidden,
    cssCutoffMs
  } = LOADING_VEIL_VARIANTS[variant];
  const [hasFadedOut, setHasFadedOut] = useState(false);
  let t2;
  let t3;
  if ($[0] !== isRemovedOnceHidden || $[1] !== isVisible) {
    t2 = () => {
      if (isVisible || !isRemovedOnceHidden) {
        return;
      }
      const timer = window.setTimeout(() => setHasFadedOut(true), LOADING_VEIL_FADE_OUT_SECONDS * 1000);
      return () => window.clearTimeout(timer);
    };
    t3 = [isVisible, isRemovedOnceHidden];
    $[0] = isRemovedOnceHidden;
    $[1] = isVisible;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  if (hasFadedOut) {
    return null;
  }
  const t4 = cssCutoffMs !== null;
  let t5;
  if ($[4] !== className || $[5] !== extraClassName || $[6] !== t4) {
    t5 = cn("flex items-center justify-center", className, {
      [styles.loadingVeilCutoff]: t4
    }, extraClassName);
    $[4] = className;
    $[5] = extraClassName;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== cssCutoffMs) {
    t6 = cssCutoffMs === null ? undefined : {
      "--loading-veil-cutoff": `${cssCutoffMs}ms`,
      "--loading-veil-fade": `${LOADING_VEIL_FADE_OUT_SECONDS}s`
    } as CSSProperties;
    $[8] = cssCutoffMs;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== isVisible) {
    t7 = !!isVisible && <LogoIsuzu className={cn("w-24 text-red-500 lg:w-40", styles.logoBreathing)} />;
    $[10] = isVisible;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isVisible || $[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
    t8 = <BlackLayer isVisible={isVisible} durationSeconds={LOADING_VEIL_FADE_OUT_SECONDS} className={t5} style={t6}>{t7}</BlackLayer>;
    $[12] = isVisible;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};